import { DollarOutlined, LeftOutlined, RightOutlined, UnorderedListOutlined } from "@ant-design/icons";
import "./ShamrockPage.scss";
import "./ShamrockResourceCenter.scss";
import { Carousel } from "antd";
import { useRecoilState } from "recoil";
import { memberState } from "../../state/atoms";
import CheckmarkIcon from "../icons/content-pages/CheckmarkIcon";
import { useEffect } from "react";

export default function ShamrockPage() {
  const [member] = useRecoilState(memberState);

  useEffect(() => {
    let meta = document.createElement('meta');
    meta.name = "robots";
    meta.content = "noindex";
    document.getElementsByTagName('head')[0].prepend(meta);
  }, [])

  function startChat() {
    Intercom('show');
  }

  const logosList = <>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/ElRanchoLogo.png" alt="El Rancho Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/RawLogo.png" alt="NW Raw Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/MochileroLogo.png" alt="Mochilero Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/Club55Logo.jpeg" alt="Club 55 Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/DoolittleLogo.jpeg" alt="Doolittle's Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/DocsRibCageLogo.png" alt="Doc's Rib Cage Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/HiltonLogo.jpeg" alt="Hilton Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/CestBonLogo.png" alt="Cest Bon Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/HardRockCafeLogo.jpeg" alt="Hard Rock Cafe Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/KrazyKarlsLogo.jpeg" alt="Krazy Karl's Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/MidCityTavernLogo.png" alt="Mid City Tavern Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/MemoriesLogo.png" alt="Memories Charcoal House Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/MickeySpillaneLogo.jpeg" alt="Mickey Spillane's Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/OleLogo.png" alt="Ole Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/PestoLogo.png" alt="Pesto Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/RebelBBQLogo.png" alt="Rebel BBQ Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/TheFortLogo.png" alt="The Fort Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/RitzCarltonLogo.jpeg" alt="Ritz Carlton Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/SarasPorchLogo.png" alt="Sara's Porch Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/SidneyDairyBarnLogo.png" alt="Sidney Dairy Barn Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/EmberLogo.jpeg" alt="Ember Woodfired Foods Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/StuffedEatsLogo.png" alt="Stuffed Eats Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/FlippinEggLogo.png" alt="That Flippin' Egg Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/TheEmbassyLogo.png" alt="The Embassy Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/BlockLogo.jpeg" alt="The Block Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/TikisLogo.png" alt="Tiki's Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/WhipLogo.png" alt="Whip Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/FrankGrizzlysLogo.png" alt="Frank Grizzly's Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/GinosLogo.png" alt="Gino's Logo" />
    </div>
  </>;

  return (
    <main className="shamrock-content shamrock-resource-showcase-content">
      <section className="one text-center">
        <Carousel autoplay autoplaySpeed={8000} arrows nextArrow={<RightOutlined />} prevArrow={<LeftOutlined />} dots={false}>
          <div className="hero-slide smart">
            <div className="slide-overlay" />
            <div className="slide-content">
              <img src="https://timber.mhmcdn.com/site/content/shamrock/MHMxShamrockLogo.svg" alt="MustHaveMenus x Shamrock Logo" />
              <h1>Smart Designs for Restaurants</h1>
              <h3>See why over 10,000 restaurants use MustHaveMenus</h3>
            </div>
          </div>

          <div className="hero-slide market">
            <div className="slide-overlay" />
            <div className="slide-content">
              <img src="https://timber.mhmcdn.com/site/content/shamrock/MHMxShamrockLogo.svg" alt="MustHaveMenus x Shamrock Logo" />
              <h1>Market effectively.</h1>
              <h3>Create restaurant-style menus and promos with little effort. Connect with your customers everywhere in print or digital.</h3>
            </div>
          </div>

          <div className="hero-slide grow">
            <div className="slide-overlay" />
            <div className="slide-content">
              <img src="https://timber.mhmcdn.com/site/content/shamrock/MHMxShamrockLogo.svg" alt="MustHaveMenus x Shamrock Logo" />
              <h1>Grow sales.</h1>
              <h3>Sell more to repeat customers with a strong restaurant brand that communicates clearly and consistently across all channels.</h3>
            </div>
          </div>

          <div className="hero-slide reduce">
            <div className="slide-overlay" />
            <div className="slide-content">
              <img src="https://timber.mhmcdn.com/site/content/shamrock/MHMxShamrockLogo.svg" alt="MustHaveMenus x Shamrock Logo" />
              <h1>Reduce hassle.</h1>
              <h3>Skip the generic design apps. Use a tool built for restaurants that can reuse menu data and sync with your POS.</h3>
            </div>
          </div>
        </Carousel>
      </section>



      <section className={"one-resource"}>
        <div className="content">
          <div className={"flex"}>
            <div className={"half text"}>
              <img src="https://timber.mhmcdn.com/site/content/shamrock/menu-services/MHMxShamrockLogo.svg" alt="MustHaveMenus x Shamrock" />
              <h1>Who is MustHaveMenus?</h1>
              <p>
                MustHaveMenus provides full-service and DIY design tools and templates for restaurants. Get everything you need for effective print menus, digital signage, QR menus and more.
              </p>
            </div>
            <div className={"half video"}>
              <iframe width="550" height="315" src="https://www.youtube.com/embed/eJdpy_2DjI0" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            </div>
          </div>
        </div>
      </section>

      <section className="two-resource">
        <div className="content">
          <div className="flex">
            <div className="item">
              <div>25k</div>
              <p>Anyone can be a designer with over 25,000 different templates to customize</p>
            </div>
            <div className="item">
              <DollarOutlined />
              <p>
                Shamrock customers receive huge discounts on MustHaveMenus products.<br />
                <b>75% off menu design<br />
                  20% off first-time subscription purchase<br />
                  10% off print orders</b>
              </p>
            </div>
            <div className="item">
              <img src="https://timber.mhmcdn.com/site/marketing/icons/Calendar1-2Thick.svg" alt="Calendar 1-2 business days" />
              <p>1-2 business days turnaround on custom menu projects</p>
            </div>
            <div className="item">
              <img src="https://timber.mhmcdn.com/site/marketing/icons/PaintbrushIcon.svg" alt="Paintbrush" />
              <p>Make updates anywhere, anytime without needing a designer</p>
            </div>
          </div>
        </div>
      </section>

      <section className={"three-resource"}>
        <div className="content">
          <h2>MustHaveMenus Differentiators</h2>
          <div className={"flex"}>
            <div className={"half"}>
              <ul>
                <li>
                  <div><img src="https://timber.mhmcdn.com/site/marketing/icons/DesignSets.svg" alt="Design Sets" /></div>
                  <div>
                    <p>World's Largest Menu Collection</p>
                    <p>Over 25,000 customizable templates and counting.</p>
                  </div>
                </li>
                <li>
                  <div><img src="https://timber.mhmcdn.com/site/marketing/icons/Megaphone.svg" alt="Megaphone" /></div>
                  <div>
                    <p>One-stop Shop</p>
                    <p>All your restaurant marketing materials like flyers, posters, business cards, and more in one convenient location.</p>
                  </div>
                </li>
                <li>
                  <div className={"small-icon"}><img src="https://timber.mhmcdn.com/site/marketing/icons/QRCode.svg" alt="QR Code" /></div>
                  <div>
                    <p>Digital Tools</p>
                    <p>Share your designs with the world using our dynamic QR codes and sharelinks.</p>
                  </div>
                </li>
                <li>
                  <div><img src="https://timber.mhmcdn.com/site/marketing/icons/OnlineMenus.svg" alt="Mobile Menus" /></div>
                  <div>
                    <p>Made for Restaurants</p>
                    <p>All products, print or otherwise, are tailored to the specific needs of the food industry.</p>
                  </div>
                </li>
                <li>
                  <div className={"small-icon"}><img src="https://timber.mhmcdn.com/site/marketing/icons/Star.svg" alt="Star" /></div>
                  <div>
                    <p>Free-to-Try Options</p>
                    <p>We know budgets are tight, so we offer a robust Free Program that's not hidden behind a paywall.</p>
                  </div>
                </li>
                <li>
                  <div className={"small-icon"}><img src="https://timber.mhmcdn.com/site/marketing/icons/CustomerService.svg" alt="CS" /></div>
                  <div>
                    <p>Expert Customer Support</p>
                    <p>Friendly customer service experts are ready to help resolve any issue, usually in a matter of minutes.</p>
                  </div>
                </li>
              </ul>
            </div>
            <div className={"half"}>
              <ul>
                <li>
                  <div><img src="https://timber.mhmcdn.com/site/marketing/icons/Printer.svg" alt="Printer" /></div>
                  <div>
                    <p>The Print Pros</p>
                    <p>Printing done right for restaurants. Covers a variety of products like sandwich boards, folded takeout menus, and business cards. Plus you have the option for high-quality finishes and laminates.</p>
                  </div>
                </li>
                <li>
                  <div className={"small-icon"}><UnorderedListOutlined /></div>
                  <div>
                    <p>POS Integrations</p>
                    <p>Seamlessly pull data from POS providers into your designs. Keep all your data synced with our Design Updater.</p>
                  </div>
                </li>
                <li>
                  <div className={"small-icon"}><img src="https://timber.mhmcdn.com/site/marketing/icons/DigiBoard.svg" alt="DMBs" /></div>
                  <div>
                    <p>Digital Menu Boards</p>
                    <p>Create digital menus and signage for various screen sizes. Simple to design, display and update.</p>
                  </div>
                </li>
                <li>
                  <div><img src="https://timber.mhmcdn.com/site/marketing/icons/Hospitality.svg" alt="Menu Services" /></div>
                  <div>
                    <p>Menu Services</p>
                    <p>Menu Services can create professional menu designs using your data for only $49/page. <i>That's a 75% discount from our regular pricing!</i></p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className={"four-resource"}>
        <div className="content">
          <h2>Customer Journey</h2>
          <img src={'https://timber.mhmcdn.com/site/content/resource-showcase/CustomerJourney.webp'} alt={"Customer Journey"} />
          <div className={"flex"}>
            <div className={"item"}>
              <div>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/ChooseTemplate.svg" alt="Choose template" />
              </div>
              <h3>Choose a Template</h3>
              <p>
                Pick from over 25,000 templates for <a href="/menu/browse.do">menus</a>, <a href="/category/takeout-menus.html">takeouts</a>, <a href="/category/restaurant-flyer.html">flyers</a>, <a href="/category/table-tent.html">tents</a>, <a href="/category/business-cards.html">cards</a>, <a href="/category/restaurant-posters.html">posters</a>, <a href="/category/stickers.html">stickers</a> and more.
              </p>
            </div>
            <div className={"arrow"}>
              <img src="https://timber.mhmcdn.com/site/marketing/icons/Arrow.svg" alt="Arrow" />
            </div>
            <div className={"item"}>
              <div>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/PaintbrushIcon.svg" alt="Paintbrush" />
              </div>
              <h3>Customize</h3>
              <p>
                Use our easy <a href="/feature/menu-maker.html">menu maker</a> to add your menu items, change fonts, styles and more.
              </p>
            </div>
            <div className={"arrow"}>
              <img src="https://timber.mhmcdn.com/site/marketing/icons/Arrow.svg" alt="Arrow" />
            </div>
            <div className={"item"}>
              <div>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/QRCode.svg" alt="QR Code" />
              </div>
              <h3>Create Links</h3>
              <p>
                Share your designs with your customers and followers.
              </p>
            </div>
            <div className={"arrow"}>
              <img src="https://timber.mhmcdn.com/site/marketing/icons/Arrow.svg" alt="Arrow" />
            </div>
            <div className={"item"}>
              <div>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/Printer.svg" alt="Printer" />
              </div>
              <h3>Print</h3>
              <p>
                Enjoy restaurant-quality printing of menus, signage, marketing and more.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className={"perks-one"}>
        <div className="content">
          <h2>Perks of working with MustHaveMenus</h2>
          <div className={"flex"}>
            <div className={"half"}>
              <img src={"https://timber.mhmcdn.com/site/content/shamrock/MenuServices.webp"} alt="Menu Services" />
            </div>
            <div className={"half"}>
              <h2>Menu Services</h2>
              <p>
                <b>Submit a request:</b> Select your service, then complete the submission form
              </p>
              <p>
                <b>Connect with a menu expert:</b> Once we've received your submission, we'll be in touch to confirm details and request payment
              </p>
              <p>
                <b>Get a menu within 1-2 business days, or less:</b> Our team will make the design available in your account, so you have complete access to the project
              </p>
              <p className="shamrock-perk">*Shamrock customers receive 75% off menu services!</p>
              <a href={member.id ? '/feature/book-demo-auth.html' : '/feature/book-demo-hello.html'} className={"ant-btn ant-btn-primary"} target="_blank" rel="noreferrer">Book a Demo</a>
            </div>
          </div>
        </div>
      </section>

      <section className={"perks-two"}>
        <div className="content">
          <div className={"flex reverse"}>
            <div className={"half"}>
              <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/MenuSet.webp"} alt="Menu Set" />
            </div>
            <div className={"half text"}>
              <h2>Membership Plans</h2>
              <p>
                <b>Free Access:</b> Ability to customize thousands of templates, download designs, and use QR codes.
              </p>
              <p>
                <b>7-day Free Trial:</b> Access to all pro features for 7 days. No card info required.
              </p>
              <p>
                <b>Paid Pro:</b> Access to every single template and feature. Upgrades from free trial to paid automatically after 7 days.
              </p>
              <p className="shamrock-perk">*Shamrock customers receive 20% off of their Pro Plan subscription! Use coupon code: SFSUB20 during checkout.</p>
              <a href={member.id ? '/feature/book-demo-auth.html' : '/feature/book-demo-hello.html'} className={"ant-btn ant-btn-primary"} target="_blank" rel="noreferrer">Book a Demo</a>
            </div>
          </div>
        </div>
      </section>

      <section className={"perks-three"}>
        <div className="content">
          <div className={"flex"}>
            <div className={"half"}>
              <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/PrintServices.webp"} alt="Print Services" />
            </div>
            <div className={"half text"}>
              <h2>Print Services</h2>
              <p>
                MustHaveMenus offers professional-quality printing for restaurants directly within our design app. It's just one click to all the options you'd expect from a top printer. We handle over 10,000 prints job a year across 14 different print products:
              </p>
              <p className="shamrock-perk">*Shamrock customers receive a 10% discount on all print orders. Use coupon code: SFPRINT10 during checkout.</p>
              <div className={"list-holder"}>
                <ul>
                  <li>Traditional Menus</li>
                  <li>Takeout Menus</li>
                  <li>Half Page Menus</li>
                  <li>Flyers</li>
                  <li>Table Tents</li>
                  <li>Kids Menus</li>
                  <li>Posters</li>
                </ul>
                <ul>
                  <li>Business Cards</li>
                  <li>Loyalty Cards</li>
                  <li>Stickers & Labels</li>
                  <li>Sandwich Boards</li>
                  <li>Gift Certificates</li>
                  <li>Comment Cards</li>
                  <li>Rack Cards</li>
                </ul>
              </div>
              <a href={member.id ? '/feature/book-demo-auth.html' : '/feature/book-demo-hello.html'} className={"ant-btn ant-btn-primary"} target="_blank" rel="noreferrer">Book a Demo</a>
            </div>
          </div>
        </div>
      </section>

      <section className={"eight-resource"}>
        <div className="content">
          <div className={"flex"}>
            <div className={"half"}>
              <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/CustomerCare.webp"} alt="Customer Care" />
            </div>
            <div className={"half"}>
              <h2>Customer Care</h2>
              <p>Unlike most online companies, we employ a real customer service team to support our restaurants at every stage of the process. From choosing a template to nailing the design, our team of friendly customer service experts are here to help create your dream design.</p>
              <div className={"ant-btn secondary"} onClick={startChat}>Chat with us</div>
            </div>
          </div>
        </div>
      </section>

      <section className={"nine-resource"}>
        <div className="content">
          <h2>Features & Benefits</h2>
          <div className={"flex"}>
            <div className={"column"}>
              <h3>Design</h3>
              <ul>
                <li>
                  <CheckmarkIcon />
                  <div>20,000+ templates</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Eye-dropper and gradient tools</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Combine multiple designs</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Ruler guide for easy formatting</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Brand management tool</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Custom fonts</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Column controls</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Highlight boxes</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Item layouts</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Document resizing</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Change backgrounds</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>1 million+ image library</div>
                </li>
              </ul>
            </div>
            <div className={"column"}>
              <h3>Printing</h3>
              <ul>
                <li>
                  <CheckmarkIcon />
                  <div>Restaurant-proof papers</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Menu lamination</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Folded takeouts come ready-to-use</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Standard 12pt cardstock for a weighty feel</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Next-day shipping</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Print helper for satisfaction guarantee</div>
                </li>
              </ul>
            </div>
            <div className={"column"}>
              <h3>Digital</h3>
              <ul>
                <li>
                  <CheckmarkIcon />
                  <div>QR codes for any design</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Video support for Digital Menu Boards & social posts</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Mobile menus</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Link pages for your socials</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Free social media posts for every occasion</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Provide the best mobile experience</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Easy to update and share</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Reach new customers wherever, whenever</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>All digital tools connect seamlessly with printed ones</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Campaigns can be pushed live in minutes</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Encourage more online orders</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>Measure and track what works</div>
                </li>
                <li>
                  <CheckmarkIcon />
                  <div>All digital tools are free to use</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className={"ten-resource"}>
        <div className="content">
          <h2>Video Resources</h2>
          <div className={"flex"}>
            <div>
              <iframe width="352" height="200" src="https://www.youtube.com/embed/eJdpy_2DjI0" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              <p>MustHaveMenus Overview</p>
            </div>
            <div>
              <iframe width="352" height="200" src="https://www.youtube.com/embed/0Ye201-6h-8" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              <p>The Menu Maker</p>
            </div>
            <div>
              <iframe width="352" height="200" src="https://www.youtube.com/embed/PG-r-xipzbc" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              <p>Design Templates</p>
            </div>
            <div>
              <iframe width="352" height="200" src="https://www.youtube.com/embed/K3G0gfOVfCk" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              <p>Printing</p>
            </div>
            <div>
              <iframe width="352" height="200" src="https://www.youtube.com/embed/PWHcvT2KFRo" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              <p>Digital Signage</p>
            </div>
            <div>
              <iframe width="352" height="200" src="https://www.youtube.com/embed/Fi2g4j79tSs" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              <p>Menu Services</p>
            </div>
          </div>
        </div>
      </section>

      <section className={"eleven-resource"}>
        <div className="content">
          <h2>Sales Sheets</h2>
          <div className={"flex"}>
            <div>
              <a href="https://timber.mhmcdn.com/site/salessheets/06%20MHM%20Sales%20Sheet%20MHMxShamrock.pdf" target="_blank" rel="noreferrer">
                <img src={"https://timber.mhmcdn.com/site/content/shamrock/TutorialShamrock.webp"} alt={"MHM x Shamrock Preview"} />
              </a>
              <p>MHM x Shamrock</p>
            </div>
            <div>
              <a href="https://timber.mhmcdn.com/site/salessheets/01%20MHM%20Sales%20Sheet%20Overview.pdf" target="_blank" rel="noreferrer">
                <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/TutorialOverview.webp"} alt={"Overview Preview"} />
              </a>
              <p>Overview</p>
            </div>
            <div>
              <a href="https://timber.mhmcdn.com/site/salessheets/02%20MHM%20Sales%20Sheet%20The%20Menu%20Maker.pdf" target="_blank" rel="noreferrer">
                <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/TutorialMenuMaker.webp"} alt={"Menu Maker Preview"} />
              </a>
              <p>The Menu Maker</p>
            </div>
            <div>
              <a href="https://timber.mhmcdn.com/site/salessheets/03%20MHM%20Sales%20Sheet%20Digital%20Tools%20A.pdf" target="_blank" rel="noreferrer">
                <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/TutorialDigitalTools.webp"} alt={"Digital Tools Preview"} />
              </a>
              <p>Digital Tools</p>
            </div>
            <div>
              <a href="https://timber.mhmcdn.com/site/salessheets/04%20MHM%20Sales%20Sheet%20Printing.pdf" target="_blank" rel="noreferrer">
                <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/TutorialPrinting.webp"} alt={"Printing Preview"} />
              </a>
              <p>Printing</p>
            </div>
            <div>
              <a href="https://timber.mhmcdn.com/site/salessheets/05%20MHM%20Sales%20Sheet%20Testimonials.pdf" target="_blank" rel="noreferrer">
                <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/TutorialTestimonials.webp"} alt={"Testimonials Preview"} />
              </a>
              <p>Testimonials</p>
            </div>
            <div></div>
            <div></div>
          </div>
        </div>
      </section>

      <section className="two text-center">
        <div className="content">
          <h2>Easily create effective menus and marketing</h2>
          <div className="flex">
            <div className="item">
              <a href="/feature/Print-Services.html">
                <img src="https://timber.mhmcdn.com/site/content/shamrock/TraditionalPrintThumb.webp" alt="Traditional print thumbnail" />
              </a>
              <h3>Traditional Print</h3>
              <p>Give your customers a beautiful printed menu to help create that timeless mystique of dining out.</p>
            </div>
            <div className="item">
              <a href="/feature/menu-qr-code.html">
                <img src="https://timber.mhmcdn.com/site/content/shamrock/QRCodesThumb.webp" alt="QR codes and web links thumbnail" />
              </a>
              <h3>QR Codes & Web links</h3>
              <p>Post your menus online in a mobile-optimized, Google-friendly format.</p>
            </div>
            <div className="item">
              <a href="/category/digital-menu-boards.html">
                <img src="https://timber.mhmcdn.com/site/content/shamrock/DigitalSignageThumb.webp" alt="Digital signage thumbnail" />
              </a>
              <h3>Digital Signage</h3>
              <p>Use our easy-to-edit menu board templates for your large-screen restaurant displays.</p>
            </div>
            <div className="item">
              <a href="/category/marketing-templates.html">
                <img src="https://timber.mhmcdn.com/site/content/shamrock/MarketingThumb.webp" alt="Marketing thumbnail" />
              </a>
              <h3>Marketing</h3>
              <p>Engage customers at your tables, at the register, in store windows, on social media, and more.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="four text-center">
        <div className="content">
          <h2>Trusted by restaurants everywhere</h2>
          <div className="moving-carousel">
            <div className="carousel-track">
              {/* Logos looped twice for animation */}
              {logosList}
              {logosList}
            </div>
          </div>
        </div>
      </section>

      <section className="five">
        <div className="content">
          <div className="flex">
            <div className="text">
              <img className="quotes" src="https://timber.mhmcdn.com/site/marketing/icons/Quotes.svg" alt="Red quotes" />
              <img className="logo" src="https://timber.mhmcdn.com/site/content/shamrock/MochileroLogoWhite.svg" alt="Mochilero Kitchen logo" />
              <h3>I always wanted to improve our menu. </h3>
              <p>
                In the past, we used graphic designers to create our menus, but simple menu updates could take weeks to get back and the designs didn't always meet our expectations. MustHaveMenus changed all that. Their friendly customer success team listened to my vision, took all my branding materials and menu data, and created a unique menu design that perfectly captures my restaurant. I love it!
              </p>
              <p><b>Jorge // Mochilero</b></p>
            </div>
            <div className="img">
              <img src="https://timber.mhmcdn.com/site/content/shamrock/MochileroKitchenHero.webp" alt="Mochilero Kitchen hero" />
            </div>
          </div>
        </div>
      </section>

      <section className="six">
        <div className="content">
          <div className="flex">
            <div className="img">
              <img src="https://timber.mhmcdn.com/site/content/shamrock/DesignProductsHero.webp" alt="Design products hero" />
            </div>
            <div className="text">
              <h2>Our Design Products</h2>
              <p>Explore over 25,000 templates tailored for restaurant marketing.</p>
              <div className="lists">
                <ul>
                  <li>Standard menus</li>
                  <li>Folded takeouts</li>
                  <li>Table tents</li>
                  <li>Half page menus</li>
                  <li>Kids menus</li>
                  <li>Business cards</li>
                  <li>Rack cards</li>
                  <li>Loyalty cards</li>
                  <li>Gift certificates</li>
                  <li>Posters</li>
                </ul>
                <ul>
                  <li>Flyers</li>
                  <li>Sandwich boards</li>
                  <li>Stickers</li>
                  <li>Digital menu boards</li>
                  <li>Mobile menu app</li>
                  <li>Linktree pages</li>
                  <li>QR codes</li>
                  <li>Social media posts</li>
                  <li>and more!</li>
                </ul>
              </div>
              <a href={member.id ? '/feature/book-demo-auth.html' : '/feature/book-demo-hello.html'} className="ant-btn ant-btn-primary" target="_blank" rel="noreferrer">Book a Demo</a>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}